import { render, staticRenderFns } from "./SubscribeMailingList.vue?vue&type=template&id=13c60354&scoped=true"
var script = {}
import style0 from "./SubscribeMailingList.vue?vue&type=style&index=0&id=13c60354&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c60354",
  null
  
)

export default component.exports